module.exports = __webpack_public_path__ + "static/media/thermomix.7fa2f326.svg";